/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PencilOutline from './pencil-outline-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PencilOutline {...validProps} />;
}
SvgComponent.iconName = 'pencilOutline';

export const PencilOutlineIcon = svgIconWrapper(SvgComponent);
